module.exports = __webpack_public_path__ + "media/images/icon-asterisk-1f733a1990a9d79cdd33423b8436e692.svg";